// apiUrls.js

const Config = {
  baseURL: 'https://api.eissecurite.com/api',  
   };
  
  export default Config;  